import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from '../../../services/api';
import "./style.css";

function Login() {
  const navigate = useNavigate();
  const [usuario, setusuario] = useState("");
  const [senha, setsenha] = useState("");
  const [sucesso, setsucesso] = useState("");
  const [loading, setloading] = useState(false);
  const [licenca, setlicenca] = useState("");

  useEffect(() => {
    localStorage.clear(); // só limpa na primeira vez
  }, []);

  function VerificaLicenca() {
    api.get("v1/licenca").then((response) => {
      if (response.data.dia > 3) {
        setloading(false);
        setlicenca("N");
      } else {
        setlicenca("S");
        setsucesso("S");
        navigate("/home");
      }
    });
  }

  function ProcessaLogin(e) {
    e.preventDefault();
    setsucesso("");
    setloading(true);

    api.post("v1/login", { usuario, senha })
      .then((response) => {
        localStorage.setItem("tempCodUsuario", response.data.codusuario);
        localStorage.setItem("tempUsuario", response.data.usuario);
        localStorage.setItem("tempCodEmpresa", response.data.codempresa);
        localStorage.setItem("tempCodFuncionario", response.data.codfuncionario);
        localStorage.setItem("tempToken", response.data.token);

        VerificaLicenca();
      })
      .catch((err) => {
        setsucesso("N");
        setloading(false);
        console.log(err);
      });
  }

  return (
    <div className="container">
      <div className="col-sm-12 d-flex justify-content-center align-items-center text-center">

        <form className="form-login">
          <h3 className="mb-4">Sistema de Joias</h3>
          <h6 className="mb-3">Faça o login</h6>

          <div className="form-floating">
            <input
              onChange={(e) => setusuario(e.target.value)}
              type="text"
              className="form-control"
              id="edtUsuario"
              placeholder="Usuário"
            />
            <label htmlFor="edtUsuario">Usuário</label>
          </div>

          <div className="form-floating">
            <input
              onChange={(e) => setsenha(e.target.value)}
              type="password"
              className="form-control"
              id="edtSenha"
              placeholder="Senha"
            />
            <label htmlFor="edtSenha">Senha</label>
          </div>

          <button
            onClick={ProcessaLogin}
            className="w-100 btn btn-lg laranja"
            disabled={loading}
          >
            {loading ? (
              <div>
                <span
                  className="spinner-border spinner-border-sm text-light"
                  role="status"
                ></span>
                <span className="ms-2">Autenticando...</span>
              </div>
            ) : (
              <span className="ms-2">Acessar</span>
            )}
          </button>
          {sucesso === "N" ? (
            <div className="alert alert-danger mt-2" role="alert">
              Usuário ou senha inválidos
            </div>
          ) : null}
          {licenca === "N" ? (
            <div className="alert alert-danger mt-2" role="alert">
              Sua licença expirou, entre em contato com o suporte do sistema
            </div>
          ) : null}
        </form>
      </div>
    </div>
  );
}

export default Login;
